import React, { PureComponent, PropTypes } from 'react'
import { Link } from 'react-router'
import styles from './styles'

export default class Button extends PureComponent {
  static propTypes = {
    onClick: PropTypes.func,
    children: PropTypes.any,
    href: PropTypes.string,
    fullWidth: PropTypes.bool,
  }

  get className() {
    return this.props.fullWidth ? styles.full : styles.button
  }

  get isLink() {
    return !!this.props.href
  }

  render() {
    const { onClick, children, href } = this.props
    const Comp = this.isLink ? Link : 'button'
    const props = { className: this.className, onClick }
    if (this.isLink) props.to = href

    return <Comp {...props}>{children}</Comp>
  }
}



/** WEBPACK FOOTER **
 ** ../app/Components/Button/Button.js
 **/